// @ts-check

import React from 'react';
import { array, object } from 'prop-types';
import ProfilePaper from './ProfilePaper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ProfileAutocomplete from './ProfileAutocomplete';

/**
 * @component ProfileCompany
 * @param {Object} props
 * @param {ProfileUser} props.user
 * @param {CompanyType[]} props.companies
 * @returns {JSX.Element}
 */
function ProfileCompany({ user, companies }) {
	return (
		<ProfilePaper>
			<Typography variant="button">COMPANY</Typography>
			<Grid container spacing={2}>
				<Grid item lg={6} xs={12}>
					<ProfileAutocomplete
						name="Name"
						label="Companies"
						options={companies}
						values={companies.filter((company) => user.companies.some((id) => company.Id === id))}
					/>
				</Grid>
				<Grid item lg={6} xs={12}>
					<ProfileAutocomplete
						name="Name"
						label="Accessible Data"
						options={companies}
						values={companies.filter((company) => company.Id === user.masterCustId)}
					/>
				</Grid>
			</Grid>
		</ProfilePaper>
	);
}

ProfileCompany.propTypes = { user: object, companies: array };

export default ProfileCompany;
